export const sortingBy = (property: string, descending = false, naturalSorting = false) => <
  T extends Record<string, string | number | undefined | any>
>(
  a: T,
  b: T,
) => {
  const valA = a[property];
  const valB = b[property];
  const mutliplier = descending ? -1 : 1;

  if (typeof valA === 'number' && typeof valB === 'number') {
    return mutliplier * (valA - valB);
  }
  if (typeof valA === 'undefined' && typeof valB === 'undefined') {
    return 0;
  }
  if (typeof valA === 'undefined' && typeof valB !== 'undefined') {
    return mutliplier * 1;
  }
  if (typeof valA !== 'undefined' && typeof valB === 'undefined') {
    return mutliplier * -1;
  }
  const options = naturalSorting ? { numeric: true } : undefined;
  return mutliplier * (valA as string).localeCompare(valB as string, undefined, options);
};
